export default __webpack_public_path__ + "3374b178e7888cb8e994d3836f375a80.svg";